export default "__VITE_ASSET__CKKUjB_J__"